import moment from "moment";

import sortDescendingOrder from "../sortDescendingOrder";

export default function sortDateDescending(a: string, b: string): number {
  return sortDescendingOrder(+moment(a), +moment(b));
}
